import { StyleSheet } from 'react-native';
import { Styles } from '../../types/projectstatus';

export default StyleSheet.create<Styles>({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentWrapper: {
    padding: 16,
  },
  filterSection: {
    backgroundColor: 'white',
    padding: 16,
    borderRadius: 8,
    marginBottom: 20,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#d9d9d9',
    borderRadius: 4,
    backgroundColor: 'white',
    width: 80,
  },
  header: {
    padding: 15,
    backgroundColor: '#F8F9FA',
    borderBottomWidth: 1,
    borderBottomColor: '#E9ECEF',
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  projectContainer: {
    padding: 15,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
  },
  projectWrapper: {
    backgroundColor: '#F8F9FA',
    borderWidth: 1,
    borderColor: '#4F4A4AFF',
    borderRadius: 12,
    marginBottom: 30,
    overflow: 'hidden',
  },
  projectHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 12,
  },
  projectTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  progressRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  projectName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000',
    flex: 1,
  },
  projectPercent: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  expectedProgress: {
    fontSize: 12,
    color: '#666',
  },
  redmineButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 4,
    backgroundColor: '#f0f0f0',
  },
  redmineIconButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    padding: 4,
    marginLeft: 4,
  },
  redmineText: {
    fontSize: 12,
    color: '#333',
  },
  statusIndicator: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#4CAF50',
  },
  statusText: {
    fontSize: 14,
    color: '#666',
  },
  disabledButton: {
    backgroundColor: '#e0e0e0',
    opacity: 0.5,
  },
  timelineContainer: {
    marginTop: 10,
    marginBottom: 15,
    paddingHorizontal: 15,
  },
  timelineHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  timeline: {
    height: 80,
    position: 'relative',
    overflow: 'visible', // overflow 추가
  },
  //계약기간 bar 스타일
  contractPeriod: {
    position: 'absolute',
    top: 10,
    height: 30,
    backgroundColor: '#0077B6',
    borderRadius: 4,
    zIndex: 2, // z-index 추가
  },
  caret: {
    marginLeft: 'auto',
    fontSize: 12,
    color: '#666',
    transform: [{ rotate: '0deg' }],
  },
  caretRotated: {
    transform: [{ rotate: '180deg' }],
  },
  //착수기간 bar 스타일
  executionPeriod: {
    position: 'absolute',
    top: 45,
    height: 30,
    backgroundColor: '#38B000',
    borderRadius: 4,
    zIndex: 1, // z-index 추가
  },
  timelineLabel: {
    position: 'absolute',
    fontSize: 10,
    color: '#FFFFFF',
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  detailText: {
    fontSize: 11,
    color: '#333',
    marginBottom: 3,
  },
  currentDate: {
    position: 'absolute',
    width: 2,
    height: '100%',
    backgroundColor: '#FF6B6B',
    zIndex: 10, // 계약기간(2), 착수기간(1)보다 위에 표시
  },
  currentDateLabel: {
    position: 'absolute',
    fontSize: 11,
    color: '#FF6B6B',
    fontWeight: 'bold',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 4,
    paddingVertical: 2,
    borderRadius: 4,
    top: -20,
    transform: [{ translateX: -30 }],
    borderWidth: 1,
    borderColor: '#FF6B6B',
    zIndex: 11, // 빨간 선보다 위에 표시
  },
  timelineLegend: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 15,
    marginTop: 10,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  legendDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  // 프로젝트 진행률 스테이지 스타일
  stagesContainer: {
    padding: 15,
  },
  stageItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  stageText: {
    flex: 1,
    fontSize: 14,
    marginRight: 10,
  },
  progressBar: {
    flex: 2,
    height: 20,
    backgroundColor: '#E9ECEF',
    borderRadius: 4,
    marginRight: 10,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#2196F3',
    borderRadius: 4,
  },
  percentageText: {
    width: 50,
    textAlign: 'right',
    fontSize: 14,
  },
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    padding: 8,
    borderRadius: 4,
    zIndex: 2000,
  },
  tooltipText: {
    color: '#fff',
    fontSize: 12,
  },
  headerTop: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
  },
  backButton: {
    padding: 10,
    marginRight: 10,
  },
  backArrow: {
    fontSize: 24,
    color: '#333',
  },
  // 페이지 네이션 스타일
  paginationContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 15,
    backgroundColor: '#fff',
    borderTopWidth: 1,
    borderTopColor: '#E9ECEF',
  },
  pageNumbers: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  pageButton: {
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 4,
    backgroundColor: '#F8F9FA',
    borderWidth: 1,
    borderColor: '#E9ECEF',
    marginHorizontal: 3,
  },
  activePageButton: {
    backgroundColor: '#2196F3',
    borderColor: '#2196F3',
  },
  pageText: {
    fontSize: 14,
    color: '#495057',
  },
  activePageText: {
    color: '#fff',
  },
  disabledText: {
    color: '#CED4DA',
  },
  navigationButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  navigationButtonText: {
    color: '#2196F3',
    fontSize: 14,
  },

  // 프로젝트 컨트롤 관련 스타일
  controlsContainer: {
    padding: 15,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#E9ECEF',
  },
  picker: {
    height: 40,
    backgroundColor: '#F8F9FA',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E9ECEF',
  },
  pickerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: 300,
    marginTop: 8,
  },
  pickerLabel: {
    fontSize: 14,
    marginRight: 10,
  },

  // 레이아웃 관련 스타일
  mainContainer: {
    flex: 1,
    backgroundColor: '#F5F7FA',
  },
  contentContainer: {
    padding: 20,
  },
  projectList: {
    gap: 15,
  },
  projectItem: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 15,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },

  // 로딩 및 에러 스타일
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    fontSize: 16,
    color: '#666',
    marginTop: 10,
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorText: {
    fontSize: 16,
    color: '#FF5252',
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#2196F3',
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 4,
  },
  retryButtonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
  },

  // 프로젝트 상세 정보 스타일
  projectDetails: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: '#f5f5f5',
    borderRadius: 5,
  },

  evenRow: {
    backgroundColor: '#FFFFFF',
  },
  oddRow: {
    backgroundColor: '#F8F9FA',
  },
  dangerText: {
    color: '#FF4444',
  },
  warningText: {
    color: '#FFA500',
  },
  dangerIndicator: {
    backgroundColor: '#FF4444',
  },
  warningIndicator: {
    backgroundColor: '#FFA500',
  },
  goodIndicator: {
    backgroundColor: 'green',
  },
  goodText: {
    color: 'green',
  },
  
  // 뉴스 관련 스타일
  newsContainer: {
    padding: 15,
    backgroundColor: '#F8F9FA',
    borderTopWidth: 1,
    borderTopColor: '#E9ECEF',
  },
  newsTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  newsContent: {
    gap: 8,
  },
  newsHeadline: {
    fontSize: 14,
    fontWeight: '500',
    color: '#333',
    marginBottom: 5,
  },
  newsDescription: {
    fontSize: 13,
    color: '#666',
    lineHeight: 20,
  },
  newsDate: {
    fontSize: 12,
    color: '#999',
    marginTop: 5,
  },
  divider: {
    height: 1,
    backgroundColor: '#E9ECEF',
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  attachmentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#e8f4f8',
    padding: 10,
    borderRadius: 5,
    marginTop: 5,
  },
  attachmentIcon: {
    marginRight: 10,
    fontSize: 16,
  },
  attachmentLink: {
    color: '#1890ff',
    textDecorationLine: 'underline',
    fontSize: 14,
  },
});